import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AiState } from './ai.reducer';

export const selectAiFeature = createFeatureSelector<AiState>('ai');

export const selectAiLoading = createSelector(
  selectAiFeature,
  state => state.loading,
);

export const selectPrompt = createSelector(
  selectAiFeature,
  state => state.prompt,
);

export const selectAiError = createSelector(
  selectAiFeature,
  state => state.error,
);

export const selectAiData = createSelector(
  selectAiFeature,
  state => state.data,
);

export const selectShowAIPanel = createSelector(
  selectAiFeature,
  state => state.showAIPanel,
);

export const selectAiModel = createSelector(
  selectAiFeature,
  state => state.model,
);

export const selectAiScenes = createSelector(
  selectAiFeature,
  state => state.data?.[state.model]?.scenes,
);
